import { useQuery } from '@tanstack/react-query';

import facilityQueries from '@facilities/utils/FacilityQueryFactory';

const useGetFacility = (id: string) => useQuery(facilityQueries.detail(id));

export default useGetFacility;
